import { CANONICAL_OPERATIONS_REGISTRY, isMaintenanceDelegableOrganizationOperation, } from '../../operations/index.js';
import { OPERATION_IDS } from '../routes/ids.js';
import { MAINTENANCE_DELEGATION_CREATE_FORM as DECLARED_FORM } from './maintenance-delegation-descriptors.js';
const DELEGABLE_OPERATION_OPTIONS = Object.values(CANONICAL_OPERATIONS_REGISTRY)
    .filter((operation) => isMaintenanceDelegableOrganizationOperation(operation.id)
    && operation.supportDelegationEligible
    && operation.allowedActorTypes.includes('SUPPORT_DELEGATE'))
    .sort((left, right) => left.id.localeCompare(right.id))
    .map((operation) => ({
    value: operation.id,
    label: operation.name,
    metadata: {
        module: operation.module,
        accessType: operation.accessType ?? (operation.isReadOnly ? 'READ' : 'ADMIN'),
    },
}));
function effectiveField(field) {
    switch (field.name) {
        case 'supportUserIdentityId':
            return {
                ...field,
                fieldType: 'select',
                optionSource: {
                    adapterId: 'api',
                    operationId: OPERATION_IDS.PLATFORM_USERS_LIST,
                    valuePath: 'userIdentityId',
                    labelPath: 'email',
                    descriptionPath: 'displayName',
                    allowSearch: true,
                    minimumSearchLength: 0,
                },
            };
        case 'targetOrganizationId':
            return {
                ...field,
                fieldType: 'select',
                optionSource: {
                    adapterId: 'api',
                    operationId: OPERATION_IDS.PLATFORM_ORGANIZATIONS_LIST,
                    valuePath: 'id',
                    labelPath: 'name',
                    descriptionPath: 'code',
                    allowSearch: true,
                    minimumSearchLength: 0,
                },
            };
        case 'allowedOperationIds':
            return {
                ...field,
                fieldType: 'multiselect',
                optionSource: undefined,
                options: DELEGABLE_OPERATION_OPTIONS,
            };
        default:
            return field;
    }
}
const fields = DECLARED_FORM.fields.map(effectiveField);
export const MAINTENANCE_DELEGATION_CREATE_FORM = Object.freeze({
    ...DECLARED_FORM,
    fields,
    sections: DECLARED_FORM.sections?.map((section) => ({ ...section })) ?? [],
    submission: {
        ...DECLARED_FORM.submission,
        includeFields: fields.map((field) => field.id),
    },
});
